module.exports = __webpack_public_path__ + "img/gereg3.624c32f9.jpg";